import { AfterViewInit, effect, Injectable, NgZone, signal, WritableSignal } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  readonly breakWidth = 992;
  isHidden: WritableSignal<boolean>;
  isOverMode = signal<boolean>(window.innerWidth < this.breakWidth);

  constructor() {
    let sessionIsHidden = sessionStorage.getItem('sidenavIsHidden');
    this.isHidden = signal<boolean>(sessionIsHidden != null ? JSON.parse(sessionIsHidden) : false);

    effect(() => {
      if(this.isHidden() != null)
        sessionStorage.setItem('sidenavIsHidden', JSON.stringify(this.isHidden()));
    });
  }

  hide() {
    this.isHidden.set(true)
  }

  show() {
    this.isHidden.set(false)
  }
}
